import React from 'react'

import { cn } from '@frame/lib/utils/cn'

type Props = {
  children: JSX.Element[] | JSX.Element
  className?: string
}
export function InfoCard({ children, className }: Props) {
  return (
    <div className={cn('rounded-md bg-moss-100 px-2 py-3 text-left text-sm text-moss-700', className)}>{children}</div>
  )
}
